import { render, staticRenderFns } from "./EditTemplateImage.vue?vue&type=template&id=f9e9bd8e&scoped=true"
import script from "./EditTemplateImage.vue?vue&type=script&lang=js"
export * from "./EditTemplateImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e9bd8e",
  null
  
)

export default component.exports